import React from "react";
import ButtonBase from "@material-ui/core/ButtonBase";

import { useStyles } from "../styles/TabControl.styles";

const TabControl = ({ isActive, logo, text, onClick, children }) => {
  const classes = useStyles();

  return (
    <ButtonBase
      focusRipple
      className={`${classes.item} ${isActive ? classes.itemActive : ""}`}
      onClick={onClick}
    >
      <img
        alt={text}
        className={classes.buttonIcon}
        src={logo}
      />
      {children}
    </ButtonBase>
  );
};

export default TabControl;
